import "./KnowledgeHub.module.css";
import Header from "@/reusable_sections/Header";
import CaseLibraryHero from "./sections/CaseLibraryHero";
import CaseStudyDirectory from "./sections/CaseStudyDirectory";
import Footer from "@/reusable_sections/Footer";
export default function KnowledgeHubPage() {
  return <div>
      <Header />
      <CaseLibraryHero />
      <CaseStudyDirectory />
      <Footer />
    </div>;
}